import { render, staticRenderFns } from "./labelManage.vue?vue&type=template&id=54e115d9&"
import script from "./labelManage.vue?vue&type=script&lang=js&"
export * from "./labelManage.vue?vue&type=script&lang=js&"
import style0 from "./labelManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports